import NavigableValidation from "./navigableValidation";
import Mapping from "~/models/mapping/mapping";
import EmbeddedCollectionValidator from "~/models/navigableValidators/embeddedCollectionValidator";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";

export default class MappingBuilderValidation<T> extends NavigableValidation<Mapping> {
  validators = [
    // new MappingValidator(this.model), // validates source/destination presence
    new EmbeddedCollectionValidator({
      validatorKey: 'model_mappings',
      section: ValidationModalSection.Mapping
    }, this.model) //validates model mappings and embedded values
  ];
}